import { EMPTY_IMAGE } from '@/utils/constants'
import { cloneDeep } from 'lodash-es'

const generateTaxModel = () => {
  return {
    vatType1: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    },
    vatType2: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    },
    vatType3: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    },
    vatType4: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    },
    vatType5: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    },
    vatType6: {
      taxBase: 0,
      vatType: 0,
      vat: 0
    }
  }
}
export default {
  data () {
    return {
      taxesError: false,
      taxesRequiredValidationError: false,
      taxes: {
        vatType1: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        },
        vatType2: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        },
        vatType3: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        },
        vatType4: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        },
        vatType5: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        },
        vatType6: {
          taxBase: 0,
          vatType: 0,
          vat: 0,
          error: false
        }
      },
      selectedVatRegion: null,
      originalTaxData: {},
      originalSelectedVatRegion: null
    }
  },
  computed: {
    companyCountry () {
      return (
        this.$store.getters['CompanyStore/currentCompany']?.defaultVatType
          ?.place || this.defaultVatRegion
      )
    },
    defaultVatRegion () {
      return this.vatTypes.find((el) => el.place === 'España')
    },
    vatTypes () {
      return this.$store.getters['TransactionsStore/vatTypes']
    },
    vatRegions () {
      if (this.selectedVatRegion && this.selectedVatRegion.id) {
        let formattedVatRegion = {
          id: this.selectedVatRegion.id,
          place: this.selectedVatRegion.place,
          vatTypes: {}
        }
        if (typeof this.selectedVatRegion.vatType1 === 'number') {
          formattedVatRegion.vatTypes['vatType1'] =
            this.selectedVatRegion.vatType1
        }

        if (typeof this.selectedVatRegion.vatType2 === 'number') {
          formattedVatRegion.vatTypes['vatType2'] =
            this.selectedVatRegion.vatType2
        }

        if (typeof this.selectedVatRegion.vatType3 === 'number') {
          formattedVatRegion.vatTypes['vatType3'] =
            this.selectedVatRegion.vatType3
        }

        if (typeof this.selectedVatRegion.vatType4 === 'number') {
          formattedVatRegion.vatTypes['vatType4'] =
            this.selectedVatRegion.vatType4
        }
        if (typeof this.selectedVatRegion.vatType5 === 'number') {
          formattedVatRegion.vatTypes['vatType5'] =
            this.selectedVatRegion.vatType5
        }

        if (typeof this.selectedVatRegion.vatType6 === 'number') {
          formattedVatRegion.vatTypes['vatType6'] =
            this.selectedVatRegion.vatType6
        }

        return formattedVatRegion
      } else {
        return this.vatTypes.find((el) => el.place === this.companyCountry)
      }
    },
    taxesInvalid () {
      if (this.fieldIsRequired('taxes')) {
        return (
          (this.taxes.vatType1.taxBase === 0 ||
            this.taxes.vatType1.taxBase === null) &&
          (this.taxes.vatType2.taxBase === 0 ||
            this.taxes.vatType2.taxBase === null) &&
          (this.taxes.vatType3.taxBase === 0 ||
            this.taxes.vatType3.taxBase === null) &&
          (this.taxes.vatType4.taxBase === 0 ||
            this.taxes.vatType4.taxBase === null) &&
          (this.taxes.vatType5.taxBase === 0 ||
            this.taxes.vatType5.taxBase === null) &&
          (this.taxes.vatType6.taxBase === 0 ||
            this.taxes.vatType6.taxBase === null)
        )
      }
      return false
    }
  },
  methods: {
    orderedVatTypes () {
      return Object.entries(this.vatRegions.vatTypes).sort(function (a, b) {
        return b[1] - a[1]
      })
    },
    // Keep just in case, this goes on the arrows, only use for transactions
    calculateTaxes (vatTypeValue, vatType) {
      if (this.transaction.amount && !this.transactionIsLocked) {
        this.resetTaxes()

        this.taxes[vatType].taxBase =
          (this.transaction.amount * -1) / (vatTypeValue / 100 + 1)
        this.handleVatCalculation(
          this.taxes[vatType].taxBase,
          vatTypeValue,
          vatType
        )
        this.checkVat()
        this.validateTaxesRequired()
      }
    },
    handleTaxInitialization (category) {
      if (!category || !category.taxCode || !this.vatRegions) return

      Object.keys(this.vatRegions.vatTypes).forEach((key) => {
        if (
          this.vatRegions.vatTypes[key] === Number.parseFloat(category.taxCode)
        ) {
          this.taxes[key].taxBase =
            Math.abs(this.transaction.amount) /
            (1 + Number.parseFloat(category.taxCode) / 100)

          this.handleVatCalculation(
            this.taxes[key].taxBase,
            this.vatRegions.vatTypes[key],
            key
          )
          this.checkVat()
        } else {
          this.taxes[key].taxBase = 0
          this.taxes[key].vat = 0
        }
      })
    },
    clearZeroTax (vatType) {
      if (this.taxes[vatType].taxBase === 0) {
        this.taxes[vatType].taxBase = null
      }
    },
    handleVatCalculation (taxBase, vatType, vatTypeField) {
      if (!taxBase) {
        if (
          this.taxes[vatTypeField].taxBase !== 0 &&
          this.taxes[vatTypeField].taxBase !== null
        ) {
          this.resetTaxField(vatTypeField)
        } else {
          this.taxes[vatTypeField].taxBase = 0
          this.taxes[vatTypeField].vat = 0
        }
      } else {
        if (vatType === null) {
          this.taxes[vatTypeField].vat = 0
          this.taxes[vatTypeField].taxBase = 0
        }
        const vatCalculation =
          Math.round(taxBase * (vatType / 100) * 100) / 100
        this.taxes[vatTypeField].vat = vatCalculation || 0
      }
    },
    checkVat () {
      let total = 0
      Object.keys(this.taxes).forEach((vatType) => {
        total +=
          Math.round(
            (Math.abs(this.taxes[vatType].taxBase) +
              Math.abs(this.taxes[vatType].vat)) *
              100
          ) / 100
      })
      this.taxesError = false

      Object.keys(this.taxes).forEach((vatType) => {
        this.taxes[vatType].error = false
        let amount = this.amountOriginalCurrency
        if (
          total + 0.01 !== amount &&
          total - 0.01 !== amount &&
          -1 * total + 0.01 !== amount &&
          -1 * total - 0.01 !== amount &&
          total * -1 !== amount &&
          total !== amount &&
          this.taxes[vatType].taxBase !== 0
        ) {
          this.taxes[vatType].error = true
          this.taxesError = true
        }
      })
    },
    validateTaxesRequired () {
      if (this.fieldIsRequired('taxes')) {
        if (
          this.taxes.vatType1.taxBase === 0 &&
          this.taxes.vatType2.taxBase === 0 &&
          this.taxes.vatType3.taxBase === 0 &&
          this.taxes.vatType4.taxBase === 0 &&
          this.taxes.vatType5.taxBase === 0 &&
          this.taxes.vatType6.taxBase === 0
        ) {
          this.taxesRequiredValidationError = true
          return true
        } else {
          this.taxesRequiredValidationError = false
          return false
        }
      }
    },
    resetTaxField (vatType) {
      switch (vatType) {
        case 'vatType1': {
          this.taxes.vatType1.taxBase = this.receipt.taxBase1
          this.taxes.vatType1.vat = this.receipt.vat1
          break
        }
        case 'vatType2': {
          this.taxes.vatType2.taxBase = this.receipt.taxBase2
          this.taxes.vatType2.vat = this.receipt.vat2
          break
        }
        case 'vatType3': {
          this.taxes.vatType3.taxBase = this.receipt.taxBase3
          this.taxes.vatType3.vat = this.receipt.vat3
          break
        }
        case 'vatType4': {
          this.taxes.vatType4.taxBase = this.receipt.taxBase4
          this.taxes.vatType4.vat = this.receipt.vat4
          break
        }
        case 'vatType5': {
          this.taxes.vatType5.taxBase = this.receipt.taxBase5
          this.taxes.vatType5.vat = this.receipt.vat5
          break
        }
        case 'vatType6': {
          this.taxes.vatType6.taxBase = this.receipt.taxBase6
          this.taxes.vatType6.vat = this.receipt.vat6
          break
        }
        default: {
          break
        }
      }
    },
    getFlagIcon (option) {
      if (option.image_url) {
        return option.image_url
      } else {
        return EMPTY_IMAGE
      }
    },
    initializeTaxes () {
      if (
        this.transaction &&
        this.transaction.receipt &&
        this.transaction.receipt.vatTypeAssigned &&
        this.transaction.receipt.vatTypeAssigned.id
      ) {
        this.selectedVatRegion = {
          ...this.transaction.receipt.vatTypeAssigned
        }
      } else {
        this.selectedVatRegion = this.vatTypes.find((el) => el.place === this.companyCountry)
      }
      this.taxes.vatType1.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase1
          : this.receipt.taxBase1
      this.taxes.vatType1.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat1
          : this.receipt.vat1

      this.taxes.vatType2.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase2
          : this.receipt.taxBase2
      this.taxes.vatType2.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat2
          : this.receipt.vat2

      this.taxes.vatType3.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase3
          : this.receipt.taxBase3
      this.taxes.vatType3.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat3
          : this.receipt.vat3

      this.taxes.vatType4.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase4
          : this.receipt.taxBase4
      this.taxes.vatType4.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat4
          : this.receipt.vat4

      this.taxes.vatType5.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase5
          : this.receipt.taxBase5
      this.taxes.vatType5.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat5
          : this.receipt.vat5

      this.taxes.vatType6.taxBase =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.taxBase6
          : this.receipt.taxBase6
      this.taxes.vatType6.vat =
        this.transaction && this.transaction.receipt
          ? this.transaction.receipt.vat6
          : this.receipt.vat6
      this.originalTaxData = cloneDeep(this.taxes)
      this.originalSelectedVatRegion = { ...this.selectedVatRegion }
      this.checkVat()
    },
    resetTaxes () {
      this.taxes.vatType1.taxBase = 0
      this.taxes.vatType1.vat = 0
      this.taxes.vatType2.taxBase = 0
      this.taxes.vatType2.vat = 0
      this.taxes.vatType3.taxBase = 0
      this.taxes.vatType3.vat = 0
      this.taxes.vatType4.taxBase = 0
      this.taxes.vatType4.vat = 0
      this.taxes.vatType5.taxBase = 0
      this.taxes.vatType5.vat = 0
      this.taxes.vatType6.taxBase = 0
      this.taxes.vatType6.vat = 0
    },
    recalculateVat () {
      Object.keys(this.taxes).forEach((el) => {
        this.taxes[el].taxBase = 0
        this.taxes[el].vat = 0
      })
    }
  },
  created () {
    this.originalTaxData = generateTaxModel()
  }
}
